export default __webpack_public_path__ + "static/media/part_of_home.1b808e4b.png";